"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaPaper = exports.yupPaper = exports.isPaperName = exports.paperNames = exports.Orientation = void 0;
const yup = __importStar(require("yup"));
var Orientation;
(function (Orientation) {
    Orientation["Paisagem"] = "L";
    Orientation["Retrato"] = "P";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
exports.paperNames = [
    'A4',
    'Carta (Letter)',
    'Ofício (Legal)',
    'Ofício 2 (Folio)',
    'Ofício 9',
    'Customizado',
];
const isPaperName = (string) => {
    return typeof string === 'string' && string in exports.paperNames;
};
exports.isPaperName = isPaperName;
exports.yupPaper = yup.object({
    name: yup
        .mixed()
        .oneOf(Object.values(exports.paperNames))
        .required()
        .default(exports.paperNames[0])
        .label('Nome do papel'),
    orientation: yup
        .mixed()
        .oneOf(Object.values(Orientation))
        .default(Orientation.Retrato)
        .required()
        .label('Orientação'),
    width: yup.number().required().default(210).label('Largura'),
    height: yup.number().required().default(297).label('Altura'),
    marginTop: yup.number().required().default(10).label('Margem topo'),
    marginBottom: yup.number().required().default(10).label('Margem base'),
    marginLeft: yup.number().required().default(10).label('Margem esquerda'),
    marginRight: yup.number().required().default(10).label('Margem direita'),
});
exports.schemaPaper = exports.yupPaper.shape({});
